var map = {
	"./72ppi/Asset 43.png": 237,
	"./72ppi/Asset 44.png": 238,
	"./72ppi/Asset 45.png": 239,
	"./72ppi/abaka.png": 240,
	"./72ppi/afn.png": 241,
	"./72ppi/arabnet.png": 242,
	"./72ppi/avaya.png": 243,
	"./72ppi/backbase.png": 244,
	"./72ppi/banserv.png": 245,
	"./72ppi/blockchain.png": 246,
	"./72ppi/caia.png": 247,
	"./72ppi/cbon.png": 248,
	"./72ppi/coforge.png": 249,
	"./72ppi/comviva.png": 250,
	"./72ppi/consdata.png": 251,
	"./72ppi/daon.png": 252,
	"./72ppi/difc.png": 253,
	"./72ppi/expo2020.png": 254,
	"./72ppi/fintechgalaxy.png": 255,
	"./72ppi/fss.png": 256,
	"./72ppi/hyperpay.png": 257,
	"./72ppi/iib.png": 258,
	"./72ppi/infasoft.png": 259,
	"./72ppi/infobip.png": 260,
	"./72ppi/minafintech.png": 261,
	"./72ppi/neosoft.png": 262,
	"./72ppi/netcore.png": 263,
	"./72ppi/newgen.png": 264,
	"./72ppi/onespan.png": 265,
	"./72ppi/openfactor.png": 266,
	"./72ppi/oracle.png": 267,
	"./72ppi/payoneer.png": 268,
	"./72ppi/piotech.png": 269,
	"./72ppi/pwc.png": 270,
	"./72ppi/rubrik.png": 271,
	"./72ppi/scventures.png": 272,
	"./72ppi/simba.png": 273,
	"./72ppi/smartstream.png": 274,
	"./72ppi/tcs.png": 275,
	"./72ppi/temenos.png": 276,
	"./72ppi/tripwire.png": 277,
	"./72ppi/turbonomic.png": 278,
	"./72ppi/vacuumlabs.png": 279,
	"./72ppi/yethi.png": 280,
	"./NewsAffinity.jpeg": 281,
	"./Sponsor Logos.ai": 282,
	"./abaka.jpeg": 283,
	"./afn.jpeg": 284,
	"./appway.png": 285,
	"./arabnet.jpeg": 286,
	"./aroundb.png": 287,
	"./avaya.jpeg": 288,
	"./backbase.jpeg": 289,
	"./backbase.png": 290,
	"./bankserv.jpeg": 291,
	"./beincrypto.jpeg": 292,
	"./blockchain.jpeg": 293,
	"./brussels.png": 294,
	"./caia.jpeg": 295,
	"./cbon.jpeg": 296,
	"./coforge.jpeg": 297,
	"./coinmercury.jpeg": 298,
	"./coinquora.png": 299,
	"./coinrepublic.png": 300,
	"./comarch.jpeg": 301,
	"./comviva.jpeg": 302,
	"./confluent.jpg": 303,
	"./consdata.jpeg": 304,
	"./creatio.png": 305,
	"./cryptonewz.jpeg": 306,
	"./ct.jpeg": 307,
	"./daon.jpeg": 308,
	"./difc.jpeg": 309,
	"./digitalscouting.png": 310,
	"./edb.jpeg": 311,
	"./ema.png": 312,
	"./eppan.jpeg": 313,
	"./expo2020.jpeg": 314,
	"./faloos.jpg": 315,
	"./financialit.jpeg": 316,
	"./financialnigeria.png": 317,
	"./find.jpeg": 318,
	"./fintechfutures.jpeg": 319,
	"./fintechgalaxy.jpeg": 320,
	"./fintechna.jpeg": 321,
	"./fintechnews.png": 322,
	"./fintechpower.jpeg": 323,
	"./fintechtimes.jpeg": 324,
	"./freshworks.png": 325,
	"./fss.jpeg": 326,
	"./holland.png": 327,
	"./hyperpay.jpeg": 328,
	"./ibm.jpeg": 329,
	"./ids.png": 330,
	"./ie.jpg": 331,
	"./igologic.jpg": 332,
	"./iib.jpeg": 333,
	"./infobip.jpeg": 334,
	"./infrasoft.jpeg": 335,
	"./innovationtech.png": 336,
	"./koinpost.png": 337,
	"./kriptomeda.jpg": 338,
	"./listing.png": 339,
	"./microsoft.png": 340,
	"./minafintech.jpeg": 341,
	"./mobile.jpeg": 342,
	"./neosoft.jpeg": 343,
	"./netcore.jpeg": 344,
	"./network.jpg": 345,
	"./newgen.jpeg": 346,
	"./onespan.jpeg": 347,
	"./openfactor.jpeg": 348,
	"./oracle.jpeg": 349,
	"./oxford.jpeg": 350,
	"./payoneer.jpeg": 351,
	"./paypers.jpg": 352,
	"./pcn.png": 353,
	"./piotech.jpeg": 354,
	"./pwc.jpeg": 355,
	"./rakbank.png": 356,
	"./regtech.png": 357,
	"./residentialtech.png": 358,
	"./rubrik.jpeg": 359,
	"./scventures.jpeg": 360,
	"./security.png": 361,
	"./sfa.jpg": 362,
	"./silicon.jpeg": 363,
	"./simba.jpeg": 364,
	"./sinofy.png": 365,
	"./skiply.png": 366,
	"./smart.png": 367,
	"./smartmessage.png": 368,
	"./smartstream.jpeg": 369,
	"./smartstream.png": 370,
	"./sme.jpg": 371,
	"./startupnews.png": 372,
	"./sybrin.png": 373,
	"./tcs.jpeg": 374,
	"./temenos.jpeg": 375,
	"./tripwire.jpeg": 376,
	"./turbonomic.jpeg": 377,
	"./ufg.png": 378,
	"./vacuumlabs.jpeg": 379,
	"./yethi.jpeg": 380,
	"./yourTraget.png": 381,
	"./zentity.png": 382
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 693;